import React, { Component } from 'react';
import cross from '../../assets/images/shape-cross.svg';
//import banner from '../../assets/images/Banner.jpg';


export default class HowKinshipWorksModal extends Component {
    // constructor() {
    //     super()
    // }

    render() {
        if (this.props.isHKWorkModalOpen === true) {
            return (
                <div class="modal" style={{ display: 'block' }} id="How-Kinship-Works-Modal" >
                    <div class="modal-dialog how-kinship-works-modal" >
                        <div class="modal-content">
                            <div className="how-kinship-works-main-div">
                                <div class="friendly-back-link" >
                                    <img src={cross} alt="loading..." onClick={() => this.props.HideHowKinshipWorkModal()} />

                                </div>

                                <div className="container">
                                    <div class="how-kinship-works-div">
                                        <div class="row">
                                            <div class="col-md-12 col-lg-12">
                                                <div class="how-kinship-works-head-div">
                                                    <h2>Kinship helps in keeping you mentally and socially active</h2>
                                                    <p>Kinship Living is a community platform promoting mental, physical, and social well being of elders. Our aim is to build an ecosystem that would enable elderly to lead a healthy, comfortable and honoured life.</p>
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-12">
                                                <div class="how-kinship-works-btn">
                                                    <button type='button' className='btn' onClick={() => this.props.HideHowKinshipWorkModal()}>Get Started</button>
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-12">
                                                <div class="how-kinship-works-head">
                                                    <h4>About Kinship Living</h4>
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-12">
                                                <div class="how-kinship-works-seperation-line">

                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-12">
                                                <div className='how-hank-works-content-div'>
                                                    <div className='row'>
                                                        <div className='col-md-12 col-lg-12'>

                                                            


                                                                <div className='how-hank-works-content'>
                                                                    <p>We organise virtual engagement sessions that keeps community members entertained as well as give them an opportunity to meet like minded people</p>
                                                                </div>


                                                            


                                                        </div>
                                                        <div className='col-md-12 col-lg-12'>
                                                            <div class="friendly-seperation-line">
                                                            </div>
                                                        </div>
                                                        <div className='col-md-12 col-lg-12'>

                                                           

                                                               


                                                                <div className='how-hank-works-content'>
                                                                    <p>Meet your Kinship friends physically during offline entertainment events and group tours
                                                                    </p>
                                                                </div>


                                                           


                                                        </div>
                                                        <div className='col-md-12 col-lg-12'>
                                                            <div class="friendly-seperation-line">
                                                            </div>
                                                        </div>
                                                        <div className='col-md-12 col-lg-12'>

                                                            

                                                                <div className='how-hank-works-content'>
                                                                    <p>Access to exclusive deals and benefits in partnership with marquee organisations curated especially for our community members
                                                                    </p>
                                                               


                                                            </div>


                                                        </div>
                                                        <div className='col-md-12 col-lg-12'>
                                                            <div class="friendly-seperation-line">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-12">
                                                <div className='questions-main-div'>
                                                    <div className='questions-div-head'>
                                                        <h4>Frequent questions</h4>
                                                    </div>
                                                    <div class="how-kinship-works-seperation-line">

                                                    </div>
                                                    <div className='questions-div'>
                                                        <a class="" data-toggle="collapse" href="#answer1" role="button" aria-expanded="false" aria-controls="collapseExample">
                                                            Is Kinship a retirement home?
                                                        </a>
                                                    </div>
                                                    <div class="collapse" id="answer1">
                                                       
                                                           <p>Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.</p> 
                                                      
                                                    </div>
                                                    <div class="friendly-seperation-line">
                                                    </div>
                                                    <div className='questions-div'>
                                                    <a class="" data-toggle="collapse" href="#answer2" role="button" aria-expanded="false" aria-controls="collapseExample">
                                                        Is Kinship a retirement home?
                                                    </a>
                                                </div>
                                                <div class="collapse" id="answer2">
                                                <p>Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.</p> 
                                            </div>
                                            <div class="friendly-seperation-line">
                                            </div>

                                                </div>

                                            </div>


                                         { /*  <div class="col-md-12 col-lg-12">
                                                <div class="how-kinship-works-btn">
                                                    <button type="button" class="btn" onClick={() => this.props.HideHowKinshipWorkModal()}>Get Started</button>

                                                </div>
                                            </div>

            */ }

                                        </div>

                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            )
        }
        else return null
    }
}